import { ArrowRight } from "lucide-react";
import { ROLE_META, type FlowRole } from "./flowData";

interface RoleBadgeProps {
  role: FlowRole;
}

/** A single actor pill (icon + label) using the role's accent colors. */
export function RoleBadge({ role }: RoleBadgeProps) {
  const meta = ROLE_META[role];
  const Icon = meta.icon;
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-sm font-medium ${meta.bg} ${meta.text}`}
    >
      <Icon className="size-4" />
      {meta.label}
    </span>
  );
}

interface RoleBadgeListProps {
  roles: FlowRole[];
}

/**
 * Renders several roles inline. When more than one role acts, an arrow
 * between them communicates the handoff order (e.g. Admin → City).
 */
export function RoleBadgeList({ roles }: RoleBadgeListProps) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {roles.map((role, i) => (
        <div key={role} className="flex items-center gap-1.5">
          <RoleBadge role={role} />
          {i < roles.length - 1 && (
            <ArrowRight className="size-3.5 text-muted-foreground shrink-0" />
          )}
        </div>
      ))}
    </div>
  );
}
